import { useState } from "react";
import { MapPin, Layers } from "lucide-react";
import { Card, Tabs } from "antd";
import "./InteractiveMap.css";
import map from "../images/map.jpg";
const { TabPane } = Tabs;

export const InteractiveMap = ({ data }) => {
  const [activeLayer, setActiveLayer] = useState("default");
  const handleTabChange = (key) => {
    setActiveLayer(key);
  };
  const campusLocation = data?.Campus_Location || {};

  return (
    <Card className="interactive-map-card">
      <div className="interactive-map-header">
        <h2 className="interactive-map-title">Campus Location</h2>
      </div>
      <div className="interactive-map-content">
        <div className="map-container">
          <div className="map-image-wrapper">
            <img src={map} alt="Map of Campus" className="map-image" />
            <div className="map-pin-container">
              <div className="map-pin-box">
                <div className="map-pin-info">
                  <MapPin className="map-pin-icon" />
                  <div>
                    <h3 className="map-pin-title">{data.Name}</h3>
                    <p className="map-pin-address">{data.City}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="map-tabs-container">
              <div className="map-tabs-wrapper">
                <Tabs
                  activeKey={activeLayer}
                  onChange={handleTabChange}
                  className="map-tabs"
                >
                  <TabPane tab="Default" key="default" />
                  <TabPane tab="Safety" key="safety" />
                  <TabPane tab="Cost" key="cost" />
                  <TabPane tab="Transport" key="transport" />
                </Tabs>
              </div>
            </div>
          </div>

          <div className="map-layers-section">
            <div className="map-layers-info">
              <Layers className="layers-icon" />
              <span className="layers-text">
                Map Layers:{" "}
                {activeLayer.charAt(0).toUpperCase() + activeLayer.slice(1)}
              </span>
            </div>

            <button className="view-larger-link">View Larger Map</button>
          </div>

          <div className="map-details-grid">
            <div className="map-detail-item">
              <h4 className="detail-title">{"Distance to airport"}</h4>
              <p className="detail-value">
                {campusLocation.Distance_To_Airport}
              </p>
            </div>
            <div className="map-detail-item">
              <h4 className="detail-title">{"Public Transport"}</h4>
              <p className="detail-value">{campusLocation.Public_Transport}</p>
            </div>
            <div className="map-detail-item">
              <h4 className="detail-title">{"Safety Rating"}</h4>
              <p className="detail-value">{campusLocation.Safety_Rating}</p>
            </div>
            <div className="map-detail-item">
              <h4 className="detail-title">{"Cost of Living"}</h4>
              <p className="detail-value">{campusLocation.Cost_Of_Living}</p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
